export default {
  en: {
    'available_at': 'available at: {date}',
    'demolished_at': 'demolished at: {date}',
    'developed_at': 'developed at: {date}',
    'unlocked': 'unlocked',
    'locked': 'locked',
    'demolish': 'demolish',
    'club_grounds': 'club grounds',
    'available': 'available',
    'sure_you_want_to_unlock_the_slot?': 'Sure you want to unlock the slot?',
    'you_will_be_able_to_chose_the_type_afterwards': 'You will be able to chose the type after the ground has been prepared.',
    'club_ground_unlocked': 'club ground unlocked',
    'develop': 'develop',
    'develop_ground_slot': 'develop ground slot',
    'headquaters': 'headquaters',
    'public_relations': 'public relations',
    'office': 'office',
    'training': 'training',
    'scouting': 'scouting',
    'youth': 'youth',
    'effects': 'effects',
    'cancel_demolition': 'cancel demolition',
    'are_you_sure?': 'Are you sure?',
    'you_will_lose_the_type_developed_on_this_ground': 'You will lose the type developed on this ground.',
    'effect_negotiation_progress': 'negotiation progress',
    'effect_staff_member_slots': 'staff member slots',
    'effect_sponsoring_base_offer': 'sponsoring base offer',
    'effect_scouting_progress': 'scouting progress',
    'effect_training_progress': 'training progress',
    'effect_youth_training_progress': 'youth training progress',
    'aggregated_effects': 'aggregated effects',
    'price': 'price',
    'duration': 'duration',
    'unlocked_club_grounds': 'unlocked club grounds',
    'no_money_will_be_refunded': 'No money will be refunded.',
    '': '',
  }
};
